import { useQuery } from '@tanstack/react-query';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { ExpertNotFound } from '@/components/directory/ExpertNotFound';
import DraftInquiry from '@/components/draftInquiry';
import { Header } from '@/components/header';
import { VStack } from '@/components/ui/vstack';
import { ROUTES } from '@/constants/routes';
import { getUserPublicV2QueryOptions } from '@/services/getUserPublicV2';
import { ApiError } from '@/util/fetchClient';

/**
 * The route for an inquiry addressed to one expert. It checks that the expert exists before
 * the form mounts, so a stale or mistyped link lands on a clear way out instead of a form
 * with a blank profile panel beside it. Only a 404 counts as a missing expert: any other
 * failure leaves the form in place, since the expert may well exist.
 */
export default function DraftInquiryRoute() {
  const router = useRouter();

  const { id } = useLocalSearchParams<{ id: string }>();

  const { error } = useQuery({ ...getUserPublicV2QueryOptions(id), enabled: !!id });

  if (error instanceof ApiError && error.status === 404) {
    return (
      <VStack className="flex-1">
        <Header title="New Inquiry" backRoute={ROUTES.DIRECTORY} isBackButton />

        <ExpertNotFound onBrowse={() => router.replace(ROUTES.DIRECTORY)} />
      </VStack>
    );
  }

  return <DraftInquiry />;
}
